module.exports = __webpack_public_path__ + "img/IT0000100887308.9a1fcbe7.png";